import { render, staticRenderFns } from "./DashboardDerechos.vue?vue&type=template&id=ff4d1a72"
import script from "./DashboardDerechos.vue?vue&type=script&lang=js"
export * from "./DashboardDerechos.vue?vue&type=script&lang=js"
import style0 from "./DashboardDerechos.vue?vue&type=style&index=0&id=ff4d1a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports